function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { PublicRoute } from './Public';
import { RoleRoute } from './Role';
import AuthPageContainer from '../pages/auth/Container';
import Upgrade from '../pages/Upgrade/Container';
import Search from '../pages/Search/Container';
import Country from '../pages/Country';
import ValidatePayment from '../pages/Payment/Paypal';

var RootLayout = function RootLayout(props) {
  return React.createElement(Switch, null, React.createElement(PublicRoute, _extends({
    exact: true,
    path: "/login",
    view: "/login",
    component: AuthPageContainer
  }, props)), React.createElement(PublicRoute, {
    exact: true,
    path: "/login:plan",
    view: "/login",
    component: AuthPageContainer
  }), React.createElement(PublicRoute, {
    exact: true,
    path: "/signup",
    view: "/signup",
    component: AuthPageContainer
  }), React.createElement(Route, {
    exact: true,
    path: "/approve:plan",
    component: ValidatePayment
  }), React.createElement(Route, {
    exact: true,
    path: "/cancel:plan",
    component: ValidatePayment
  }), React.createElement(PublicRoute, {
    exact: true,
    path: "/reset-password",
    view: "/reset-password",
    component: AuthPageContainer
  }), React.createElement(RoleRoute, {
    exact: true,
    path: "/search",
    view: "/search",
    redirect: "/choose-plan",
    allowedRoles: ['freeTrialCustomer', 'normalCustomer', 'premiumCustomer'],
    component: Search
  }), React.createElement(RoleRoute, {
    exact: true,
    path: "/countries/ni",
    view: "/countries/ni",
    redirect: "/choose-plan",
    allowedRoles: ['freeTrialCustomer', 'normalCustomer', 'premiumCustomer'],
    component: Country
  }), React.createElement(RoleRoute, {
    exact: true,
    path: "/choose-plan",
    view: "/choose-plan",
    redirect: "/search",
    allowedRoles: ['noRole', 'freeTrialCustomer', 'normalCustomer'],
    component: Upgrade
  }), React.createElement(RoleRoute, {
    exact: true,
    path: "/choose-plan:action",
    redirect: "/search",
    allowedRoles: ['noRole', 'freeTrialCustomer', 'normalCustomer'],
    component: Upgrade
  }), React.createElement(Route, {
    render: function render(p) {
      return React.createElement(Redirect, _extends({
        to: {
          pathname: '/login'
        }
      }, props, p));
    }
  }));
};

export default RootLayout;